import {
  TELIAPAY_METHOD,
  CARD_PAYMENT_METHOD,
  SWISH_METHOD,
  type PaymentMethod,
  KLARNA_PAY_LATER_IDENTIFIER,
  KLARNA_PARTPAYMENT_IDENTIFIER,
  KLARNA_PAY_NOW_IDENTIFIER,
  ELECTRAFINANS_METHOD,
} from '~/models/checkout/PaymentMethods.model';

export const useSortPaymentMethods = (paymentMethods: PaymentMethod[] = []) => {
  let sortedPaymentMethods = paymentMethods.slice();

  const orderOfPaymentMethodsByName = [
    SWISH_METHOD,
    TELIAPAY_METHOD,
    CARD_PAYMENT_METHOD,
    ELECTRAFINANS_METHOD,
    KLARNA_PAY_NOW_IDENTIFIER,
    KLARNA_PAY_LATER_IDENTIFIER,
    KLARNA_PARTPAYMENT_IDENTIFIER,
  ];

  const paymentMethodIdentifiers = paymentMethods.map(
    (method: PaymentMethod) => method.commaSeparatedSystemNameAndIdentifier,
  );

  // Sort the payment methods according to orderOfPaymentMethodsByName
  for (const methodNameInOrder of orderOfPaymentMethodsByName.reverse()) {
    if (paymentMethodIdentifiers.includes(methodNameInOrder)) {
      const newPaymentMethods = sortedPaymentMethods.filter(
        (method: PaymentMethod) =>
          method.commaSeparatedSystemNameAndIdentifier !== methodNameInOrder,
      );
      const methodToPutFirstInOrder = paymentMethods.find(
        (method: PaymentMethod) =>
          method.commaSeparatedSystemNameAndIdentifier === methodNameInOrder,
      );
      if (methodToPutFirstInOrder) {
        newPaymentMethods.unshift(methodToPutFirstInOrder);
      }
      sortedPaymentMethods = newPaymentMethods.slice();
    }
  }

  return sortedPaymentMethods;
};
